<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Chirurgies</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter une chirurgie
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSurgery"
          identifier="B122TableSurgery"
          init-b122-table-url="/surgery/initB122Table"
          get-b122-table-results-url="/surgery/getB122TableResults"
          :fields="tableFields"
          initial-sort-by="startDate"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <surgery-delete-modal :selected="ui.selectedSurgery" @didDeleteSurgery="didDeleteSurgery()"></surgery-delete-modal>
  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import SurgeryDeleteModal from "./SurgeryDeleteModal";

export default {

  name: 'SurgeryIndex',

  components: {
    B122Table,
    SurgeryDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Date",
          key: "startDate",
          sortable: true,
          formatter: function (value, key, item) {
            return new Date(value).toLocaleDateString('fr-FR');
          }
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "Animal",
          key: "hospitalization.animal.name",
          sortable: true
        },
        {
          label: "Propriétaire",
          key: "hospitalization.animal.user.name",
          sortKey: "hospitalization.animal.user.lastName",
          sortable: true
        },
        {
          label: "Statut",
          key: "surgeryStatus.name",
          sortable: true
        },

        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedSurgery: null
      }

    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'SurgeryCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'SurgeryShow',
        params: {
          surgeryId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'SurgeryEdit',
        params: {
          surgeryId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedSurgery = row.item
      this.$bvModal.show('surgery-delete-modal')
    },

    didDeleteSurgery() {
      this.ui.selectedSurgery = null;
      this.$refs.B122TableSurgery.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgery/SurgeryIndex.vue